<template>
    <p class="student-code" @click.prevent="onCode">
        {{ $t('profile.student_code') }}:
        <span class="student-code__code">{{ code }}</span>
        <v-icon>mdi-content-copy</v-icon>
    </p>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'student-code',
    props: {
        code: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions('snackbar', [
            'setSnackbarMessage'
        ]),
        async onCode() {
            await navigator.clipboard.writeText(this.code)
            this.setSnackbarMessage({ content: this.$t('profile.student_code_message'), color: 'success' })
        }
    }
}
</script>

<style lang="scss" scoped>
.student-code {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    min-width: 270px;
    width: auto;
    max-width: 30px;
    padding: 9px;
    background-color: #ffe691;
    border-radius: 6px;
    box-shadow: -2px 2px 9px 0 rgba(0,0,0,.2);
    cursor: pointer;
    font-weight: 100;

    &__code {
        background-color: #ffd135;
        font-weight: 600;
        letter-spacing: 2px;
        padding: 0 6px;
        border-radius: 9px;
        margin: 0 6px;
    }

    @media (min-width: 600px) {
        max-width: 510px;
    }
}
</style>
